import * as Yup from 'yup';
import moment from 'moment';

export const fnameValidation = Yup.string()
  .trim()
  .label("fname")
  .required("This field is required.")
  .nullable()
  .max(30, "Maximum characters allowed 30")

export const lnameValidation = Yup.string()
  .trim()
  .label("lname")
  .required("This field is required.")
  .nullable()
  .max(30, "Maximum characters allowed 30")

export const countryValidation = Yup.string()
  .trim()
  .label("Region")
  .required("Please select a region.")
  .nullable()

export const emailValidation = Yup.string()
  .trim()
  .label('Email')
  .required('This field is required.')
  .email('Please enter a valid email address.')
  .max(100)


export const passwordValidation = Yup.string()
  .trim()
  .label("password")
  .nullable()
  .required("This field is required")
  .min(8, "Length must be greater than 8")
  .matches(/[A-Z]/, " Must contain an uppercase")
  .matches(/[a-z]/, "Must contain a lowercase")
  .matches(/[^\w]/, "Must contain a special character")
  .matches(/\d/, "Must contain a number")



export const loggedInPwdValidation = Yup.string()
  .trim()
  .label('Password')
  .nullable()
  .required('This field is required.')

export const repeatPwdValidation = Yup.string()
  .trim()
  .oneOf([Yup.ref("password"), null], "Passwords do not match.")
  .label("repeatPassword")
  .nullable()
  .required("This field is required.")


export const venueDetailsValidationSchema = Yup.object().shape({
  venue_name: Yup.string()
    .trim()
    .label('Venue Name:')
    .required('Please fill in the required information.')
    .nullable()
    .max(50),
  city: Yup.string()
    .trim()
    .label('Venue City:')
    .required('Please fill in the required information.')
    .nullable()
    .max(50),
  venue: Yup.string()
    .trim()
    .label('Venue:')
    .required('Please fill in the required information.'),
  state: Yup.string()
    .trim()
    .label('State:')
    .required('Please fill in the required information.')
    .nullable(),
  country: Yup.string()
    .trim()
    .label('County:')
    .required('Please fill in the required information.')
    .nullable(),
  postal_code: Yup.string()
    .trim()
    .label('Postal COde:')
    .required('Please fill in the required information.')
    .nullable(),
});

// A Level Cap level: blank means no limit, 0 is a real limit.
const isCapSet = (v) => v !== '' && v !== null && v !== undefined;

export const createEventDetailValidationSchema = (feisDateField, feisDateMessage) =>
  Yup.object().shape({
    name: Yup.string().required('Please fill in the required information.'),
    contact_email: Yup.string()
      .email('Please enter a valid email address.')
      .required('Please fill in the required information.'),
    region: Yup.string().required('Please Select a Region.'),
    cap: Yup.object().shape({
      capType: Yup.string().required('Please Select a Cap.'),
      value: Yup.string().when('capType', {
        is: (val) => val === 'Global Cap',
        then: Yup.string()
          .required('Value is required.')
          .matches(/^[1-9]\d*$/, 'Enter a whole number of dancers.'),
      }),
      grades: Yup.string().when('capType', {
        is: 'Level Cap',
        then: Yup.string()
          .matches(/^\d*$/, 'Enter a whole number of dancers.')
          .test(
            'level-cap-needs-a-limit',
            'Enter a limit for grades, championship, or both.',
            function (grades) {
              return isCapSet(grades) || isCapSet(this.parent.champ);
            }
          ),
      }),
      champ: Yup.string().when('capType', {
        is: 'Level Cap',
        then: Yup.string().matches(/^\d*$/, 'Enter a whole number of dancers.'),
      }),
    }),
    opening_date: Yup.date().required('Please fill in the required information.'),
    closing_date: Yup.date()
      .test({
        test: (closing_date, context) => {
          const { opening_date } = context.parent;
          if (!!closing_date && !!opening_date) {
            return closing_date.getTime() >= opening_date.getTime();
          }
          return true;
        },
        message: 'Closing date must be greater than opening date.',
      })
      .required('Please fill in the required information.'),
    [feisDateField]: Yup.date()
      .test({
        test: (date, context) => {
          const { closing_date } = context.parent;
          if (!!date && !!closing_date) {
            return date.getTime() >= closing_date.getTime();
          }
          return true;
        },
        message: feisDateMessage,
      })
      .test({
        test: (date, context) => {
          const { opening_date } = context.parent;
          if (!!date && !!opening_date) {
            return date.getTime() >= opening_date.getTime();
          }
          return true;
        },
        message: 'Feis date must be greater than the opening date.',
      })
      .required('Please fill in the required information.'),
  });

export const accValidationSchema = Yup.object().shape({
  name: Yup.string()
    .trim()
    .label('First Name:')
    .required('This field is required.')
    .nullable()
    .max(50),
  address: Yup.string()
    .trim()
    .label('Address:')
    .required('This field is required.')
    .nullable(),
  city: Yup.string()
    .trim()
    .label('Birth Year:')
    .required('This field is required.'),
  state: Yup.string()
    .trim()
    .label('School:')
    .required('This field is required.')
    .nullable(),
  country: Yup.string()
    .trim()
    .label('Country:')
    .required('This field is required.')
    .nullable(),
  postal_code: Yup.string()
    .trim()
    .label('Levels:')
    .required('This field is required.')
    .nullable(),
  description: Yup.string()
    .trim()
    .required('This field is required.')
    .nullable(),

  photo: Yup.mixed().required('File is required'),
});

// validation
export const feesValidationSchema = Yup.object().shape({
  familyfee: Yup.number()
    .min(0, 'Family fee must be greater than or equal to zero')
    .label('Family Fee:')
    .required('This field is required.'),
  familymax: Yup.number()
    .min(0, 'Family max must be greater than or equal to zero')
    .label('Family max:')
    .required('This field is required.'),
  familyless: Yup.number()
    .min(0, 'Family less must be greater than or equal to zero')
    .label('Family Less:')
    .test({
      test: (value, context) => {
        const values = context.parent;
        return !(values.familyfee && value > values.familyfee)
      },
      message: "Family Less must be less than Family Fee",
    })
    .required('This field is required.'),
  ifDateIsBefore: Yup.string()
    .label('If date is before:')
    .required('This field is required.')
    .nullable(),
  additionfee: Yup.number()
    .min(0, 'additional fee must be greater than or equal to zero')
    .label('Additional:')
    .required('This field is required.')
    .nullable(),
  afterdate: Yup.date()
    .test({
      test: (afterdate, context) => {
        const { lateafterdate } = context.parent;
        if (!!afterdate && !!lateafterdate) {
          return moment(afterdate)?.format('MM/DD/YYYY') < moment(lateafterdate)?.format('MM/DD/YYYY');
        }
        return true;
      },
      message: 'Late fee date must be less than closing date',
    })
    .required('This field is required.'),
  lateadditionfee: Yup.string()
    .min(0, 'late additional fee must be greater than or equal to zero')
    .label('Additional: ')
    .required('This field is required.')
    .nullable(),
  lateafterdate: Yup.string()
    .label('After Date: ')
    .required('This field is required.')
    .nullable(),
});

